import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmClip extends wmBase {
    constructor(options: widgetOption<string>[]) {
        super();
        this.options = options;
    }

    build() {
        if (this.options.length !== 1) {
            return "";
        }

        return `
            <div class="wm_clip">
               ${this.viewUrl}
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_clip");
        item?.removeEventListener("click", this.clipAction, false);
        item?.addEventListener("click", this.clipAction, false);
    }

    clipAction = () => {
        if (this.options.length !== 1) return;
        this.applyValue(this.options, "", false, false);
    };

    name = "wm_media";
    options: widgetOption<string>[] = [];
    viewUrl = `
        <svg width="23" height="23" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 26.6667H0V20H20V0H26.6667V93.3333H86.6667V100H20V26.6667ZM93.3333 26.6667H33.3333V20H100V93.3333H120V100H100V120H93.3333V26.6667Z" fill="black"/>
        </svg>
    `;
}
